import currency from 'currency.js'
import React from 'react'
import { UNKNOWN_CUSTOMER } from './constants'

export const ReserveFeeNotice = () => {
  const handleClick = event => {
    event.stopPropagation()
  }

  return (
    <div onClick={handleClick}>
      <p>
        The delivery fee ensures exclusive delivery to your location at a set time and varies by
        restaurant choice and other factors.
      </p>
      <br />
      <p>
        Split the delivery fee equally with others who order at your location. Once delivered, the
        fee is divided among all who ordered and credits are allocated to balance any payment
        differences.
      </p>
    </div>
  )
}

export const SplitDeliveryFeeNotice = ({ originalDeliveryFee, createdByName }) => {
  const handleClick = event => {
    event.stopPropagation()
  }

  return (
    <div onClick={handleClick}>
      <p>
        {createdByName === UNKNOWN_CUSTOMER ? `A ${UNKNOWN_CUSTOMER}` : createdByName} scheduled
        this delivery for ${originalDeliveryFee} and chose to &quot;split&quot; this fee. When you
        pay the current delivery fee and others order after you, you will earn credits back. The
        more people that order, the more credits you will earn! Credits are evenly divided among all
        who order, based on the difference between your payment and the original $
        {originalDeliveryFee} delivery fee.
      </p>
    </div>
  )
}

export const CreditsEarnedNotice = ({ deliveryFeePerPerson, deliveryFeeContribution }) => {
  return (
    <div>
      <p>
        Credits are calculated by subtracting{' '}
        <bold>{currency(deliveryFeePerPerson, { formatWithSymbol: true }).format()}</bold> from the{' '}
        <bold>{currency(deliveryFeeContribution, { formatWithSymbol: true }).format()}</bold> you
        paid. The more people who order, the more credits everyone earns back. Credits are
        calculated and issued once your meal is delivered.
      </p>
    </div>
  )
}
